import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Button, Modal, List } from '..'
import { Header, Divider, Confirmation, Buttons, Content } from './SelectConfirm.Styles'

class SelectLanguageDom extends PureComponent {
    static propTypes = {
        header: PropTypes.string.isRequired,
        list: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })
        ).isRequired,
        selected: PropTypes.string,
        onClickCancel: PropTypes.func.isRequired,
        onClickAccept: PropTypes.func.isRequired,
        isOpen: PropTypes.bool.isRequired,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        selected: null,
    }

    state = {
        highLighted: -1,
    }

    componentDidUpdate(prevProps) {
        const { selected, isOpen } = this.props
        if (prevProps.isOpen !== isOpen && selected) {
            const { list } = this.props
            const index = list.findIndex((element) => element.value === selected)
            // As we are comparing the actual props with the prevProps to avoid infinite loops, we can use setState inside componentDidUpdate
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ highLighted: index })
        }
    }

    onClickRow = (index) => {
        this.setState({ highLighted: index })
    }

    onClickAccept = () => {
        const { onClickAccept, list } = this.props
        const { highLighted } = this.state
        return onClickAccept(list[highLighted].value)
    }

    render() {
        const { header, list, onClickCancel, isOpen, t } = this.props

        const { highLighted } = this.state

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel} confirm>
                <Confirmation>
                    <Header>{header}</Header>
                    <Divider borderWidth="2px" />
                    <Content>
                        <List data={list} onClickRow={this.onClickRow} highLighted={highLighted} display="name" onlyBorderBottom />
                    </Content>
                    <Divider borderWidth="1px" />
                    <Buttons>
                        <Button theme="light" onClick={onClickCancel} size="sm">
                            {t('Cancel')}
                        </Button>
                        <Button onClick={this.onClickAccept} size="sm">
                            {t('Agree')}
                        </Button>
                    </Buttons>
                </Confirmation>
            </Modal>
        )
    }
}

export default withTranslation()(SelectLanguageDom)
